module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ExaminationItemModule', {
    attrs: {
      "isLoading": _vm.isLoading,
      "item": _vm.examination,
      "isError": _vm.isError
    },
    on: {
      "setStatus": _vm.setStatus,
      "getData": _vm.getData,
      "result": _vm.result,
      "getResult": _vm.getResult
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-433fcc35","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/views/examination-item/examinationItem.vue
// module id = e7efe949057edb7a68c5
// module chunks = 3